module.exports = __webpack_public_path__ + "img/grand-resort-3.c4b446c4.jpg";